<div class="b2aContainer" [ngClass]="getCompanyClass()">
  <app-header></app-header>
  <div class="b2aContainer__inner">
    <router-outlet></router-outlet>
  </div>
  <app-user-notification></app-user-notification>
  <app-footer [type]="'userSite'"></app-footer>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/pages.component.html